<template>
  <div>
    <div v-if="dispositivo.has_subscription_active">

      <mensagem-somente-vip-teste v-if="dispositivo.licence.trial"/>

      <Chat messenger="badoo"/>
    </div>
    <div v-else>
      <mensagem-somente-vip/>
    </div>
  </div>
</template>

<script>
import MensagemSomenteVip from '../../components/MensagemSomenteVip.vue';
import MensagemSomenteVipTeste from '../../components/MensagemSomenteVipTeste.vue';
import Chat from './Chat.vue';

export default {
  components: {
    Chat,
    MensagemSomenteVip,
    MensagemSomenteVipTeste,
  },
  data() {
    return {
      dispositivo: {},
    };
  },
  mounted() {
    this.dispositivo = JSON.parse(this.$localStorage.get('mobile'));
  },
};
</script>
